import EnrollmentHistoryDialog from './EnrollmentHistoryDialog';

export default EnrollmentHistoryDialog;
